var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('input',{attrs:{"type":"text","placeholder":"Search "}}),_c('div',[_c('img',{attrs:{"src":require("./../../assets/images/search.svg"),"alt":""}})])])
}]

export { render, staticRenderFns }